import { StringLightsOffIcon } from './StringLightsOffIcon';

/**
 * author: Michael Irigoyen
 * id F1B6F6EB-6D20-4C27-A631-8FAF759D183A
 * name string-lights-off
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/string-lights-off.svg
 * tags
 * - Home Automation 
 */
export const ItalianLightsOffIcon = StringLightsOffIcon;
export default ItalianLightsOffIcon